import React, { useState } from "react";
import TransactionFlowDefaultTemplate from "../../others/transactionFlowDefaultTemplate";
import { render } from "@testing-library/react";
import dayjs from "dayjs";
import { useNavigate } from "react-router";
import { Tooltip, Tag } from "antd";
import {
  FileTextOutlined,
  CheckCircleTwoTone,
  ExclamationCircleTwoTone,
  ClockCircleOutlined,
  FolderOpenOutlined,
  FolderOutlined,
  CloseCircleTwoTone,
  SyncOutlined,
  SmileTwoTone,
} from "@ant-design/icons";
const BAFOList = () => {
  const [sm, setSm] = useState(false);
  const navigate = useNavigate();
  const columns = [
    {
      title: "Tenders ID",
      dataIndex: "tenderNumber",
      key: "tenderNumber",
      fixed: "left",
      width: 200,
      render: (text: any, record: any) => {
        return (
          <>
            <Tooltip title={"Click To View Tender Details"}>
              <span
                className="inlineTableCellLink"
                onClick={() => {
                  navigate(`/tender/bafo-analysis/${record.tenderId}`);
                }}
              >
                {text}
              </span>
            </Tooltip>
          </>
        );
      },
    },
    {
      title: "Title",
      dataIndex: "tenderTitle",
      key: "tenderTitle",
      width: 200,
      render: (text: string) => (
        <Tooltip title={text}>
          <span
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: 160,
              display: "inline-block",
            }}
          >
            {text}
          </span>
        </Tooltip>
      ),
    },
    {
      title: "Type",
      dataIndex: "tenderType",
      key: "tenderType",
      width: 130,
      render: (type: string) => (
        <Tag
          color={type === "Open" ? "green" : "blue"}
          icon={type === "Open" ? <FolderOpenOutlined /> : <FolderOutlined />}
        >
          {type}
        </Tag>
      ),
    },
    {
      title: "Tender For",
      dataIndex: "tenderFor",
      width: 130,
      key: "tenderFor",
      render: (tenderFor: string) => (
        <Tag color={tenderFor === "Material" ? "purple" : "cyan"}>
          {tenderFor}
        </Tag>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 180,
      render: (status: string) => {
        const statusMap: Record<string, { color: string; icon: JSX.Element }> =
          {
            Draft: {
              color: "geekblue",
              icon: <ClockCircleOutlined />,
            },
            Published: { color: "cyan", icon: <CheckCircleTwoTone /> },
            "Not Interested": {
              color: "default",
              icon: <CloseCircleTwoTone twoToneColor="#d9d9d9" />,
            },
            Responded: { color: "purple", icon: <FileTextOutlined /> },
            Negotiation: { color: "orange", icon: <SyncOutlined /> },
            "Pending Approval": {
              color: "gold",
              icon: <ExclamationCircleTwoTone twoToneColor="#faad14" />,
            },
            "Completed Evaluation": {
              color: "green",
              icon: <CheckCircleTwoTone twoToneColor="#52c41a" />,
            },
            Cancelled: {
              color: "red",
              icon: <CloseCircleTwoTone twoToneColor="#ff4d4f" />,
            },
          };
        const { color, icon } = statusMap[status] || {
          color: "default",
          icon: <FileTextOutlined />,
        };
        return (
          <Tag color={color} icon={icon}>
            {status}
          </Tag>
        );
      },
    },
    {
      title: "Site / Project",
      dataIndex: "siteName",
      key: "siteName",
      width: 250,
      render: (text: any) => {
        return <span>{text || "--"}</span>;
      },
    },
    {
      title: "Version #",
      dataIndex: "amount",
      key: "amount",
      width: 100,
      render: (_text: any, _record: any) => {
        return <span>1.0</span>;
      },
    },
    {
      title: "Last Submission Date",
      dataIndex: "lastSubmissionDate",
      key: "lastSubmissionDate",
      width: 200,
      render: (text: any) => {
        return <span>{text ? dayjs(text).format("DD-MMM-YYYY") : "--"}</span>;
      },
    },
  ];
  return (
    <TransactionFlowDefaultTemplate
      moduleKey="delivery-address"
      title="Tender Analysis"
      columns={columns}
      selectFilters={[
        {
          title: "Status",
          placeholder: "Select Status",
          options: [
            { value: "Completed Evaluation", label: "Completed Evaluation" },
          ],
        },
      ]}
      extra={{
        tableScrollX: 1100,
        dateRange: false,
        excelExport: false,
      }}
    />
  );
};

export default BAFOList;
